<div id="procContainer" class=container1>
    <div id="procFactTagInfo" class="main-content paddingSection">
        <div id="ftags" class="fact_tags mt-3 clr-white">{{processor}}</div>
    </div>
</div>